import { Instagram, ArrowUp } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#09090B]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <Logo size={38} />
            <p className="font-brand text-xl uppercase whitespace-nowrap">
              Goujon Vallée
            </p>
          </div>
          <p className="mt-4 text-sm text-zinc-500 leading-relaxed font-light max-w-xs">
            Charpente, couverture et bardage en Normandie depuis plus de 20 ans.
            Le savoir-faire artisanal au service de votre toiture.
          </p>
        </div>
        <nav className="flex flex-col gap-3" data-testid="footer-nav">
          <p className="text-[10px] tracking-[0.25em] uppercase text-zinc-600 font-bold mb-2">Navigation</p>
          {[
            ["Réalisations", "#realisations"],
            ["Services", "#services"],
            ["Zone d'intervention", "#zone"],
            ["Demander un devis", "#contact"],
          ].map(([label, href]) => (
            <a key={href} href={href} data-testid={`footer-link-${href.slice(1)}`} className="text-sm text-zinc-400 hover:text-jaune transition-colors duration-300 w-fit">
              {label}
            </a>
          ))}
        </nav>
        <div className="flex flex-col gap-3">
          <p className="text-[10px] tracking-[0.25em] uppercase text-zinc-600 font-bold mb-2">Contact</p>
          <a href="mailto:contact@goujonvallee.fr" data-testid="footer-email-link" className="text-sm text-zinc-400 hover:text-jaune transition-colors duration-300 w-fit">
            contact@goujonvallee.fr
          </a>
          <a href="https://www.instagram.com/goujon_vallee" target="_blank" rel="noreferrer" data-testid="footer-instagram-link" className="flex items-center gap-2 text-sm text-zinc-400 hover:text-jaune transition-colors duration-300 w-fit">
            <Instagram className="w-4 h-4" /> @goujon_vallee
          </a>
          <a href="tel:+33235603633" data-testid="footer-phone-link" className="text-sm text-zinc-400 hover:text-jaune transition-colors duration-300 w-fit">
            02 35 60 36 33
          </a>
          <p className="text-sm text-zinc-500">330 rue de l'Avenir, 27310 Bosgouet</p>
          <a href="#accueil" data-testid="footer-back-top" className="mt-6 flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-zinc-500 hover:text-white transition-colors duration-300 w-fit">
            <ArrowUp className="w-4 h-4" /> Haut de page
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-zinc-600">
          <p>© {new Date().getFullYear()} Goujon Vallée — Tous droits réservés</p>
          <a href="/mentions-legales" data-testid="footer-mentions-legales" className="hover:text-jaune transition-colors duration-300">
            Mentions légales &amp; RGPD
          </a>
          <p>www.goujonvallee.fr</p>
        </div>
      </div>
    </footer>
  );
}
